import { useQuery } from "@tanstack/react-query";
import { salaryInfoKeys } from "apis/salary/query_keys_salary";
import {
  getSalaryInfo,
  getSalaryOverallList,
  getSalaryStaffCombo,
} from "apis/salary/salary_info_api";
import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 급여 관리 정보 받아오기
export const useSalaryInfo = (queryData) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salaryInfoKeys.info(queryData),
    queryFn: () => getSalaryInfo(queryData),
    retry: false,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};

// [GET] 급여 직원별 현황 정보 받아오기
export const useSalaryStaffInfo = (queryData) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salaryInfoKeys.overallList(queryData),
    queryFn: () => getSalaryOverallList(queryData),
    retry: false,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};

// [GET] 급여 직원 리스트 콤보 받아오기
export const useSalaryStaffCombo = (queryData) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salaryInfoKeys.staffCombo(queryData),
    queryFn: () => getSalaryStaffCombo(queryData),
    retry: false,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};
